import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../../theme';
export const useStyles = () => {
    const theme = useTheme();
    return {
        textContent: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                alignItems: 'flex-start',
            },
        },
        icon: {
            borderRadius: '50%',
            padding: theme.spacing(1.5),
            color: theme.palette.primary.contrastText,
            backgroundColor: brandColors.main,
            marginBottom: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            [theme.breakpoints.down('xs')]: {
                marginRight: theme.spacing(3),
                marginBottom: 0,
            },
            '& > svg': {
                fontSize: '2rem',
                maxWidth: '2rem',
                maxHeight: '2rem',
                [theme.breakpoints.down('xs')]: {
                    fontSize: '1.5rem',
                    maxWidth: '1.5rem',
                    maxHeight: '1.5rem',
                },
            },
        },
        disabledIcon: {
            color: theme.palette.grey[500],
            backgroundColor: theme.palette.grey[200],
            '& > svg': {
                '& path': {
                    fill: theme.palette.grey[500],
                },
            },
        },
        title: {
            MuiTypography: {
                styleOverrides: {
                    fontWeight: 900,
                    marginBottom: theme.spacing(1),
                    marginTop: theme.spacing(1),
                },
            },
        },
        paragraph: {
            marginBottom: 0,
            textAlign: 'center',
            [theme.breakpoints.down('xs')]: {
                textAlign: 'left',
            },
        },
    };
};
